import React, {Component} from 'react';
import {Button, Modal} from 'antd'

export default class ShowSQL extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    }
  }


  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }

  render() {
    return (<div>
      <Button onClick={this.showModal}>Show SQL</Button>
        <Modal
          title="Show SQL"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width='700'
          style={{'white-space': 'pre-wrap'}}>
        
        {((this.props.reportMetaData)?this.props.reportMetaData.sql:'')}
      </Modal>


    </div>)
  }
}
